import type { ParseKeys, Resources } from "i18next";

/** Clé i18n complète, préfixée par son namespace : `"validation:required"`. */
export type I18nKey = {
  [Ns in keyof Resources]: `${Ns & string}:${ParseKeys<Ns> & string}`;
}[keyof Resources];

/**
 * Message à traduire plus tard (au rendu), là où `t` n'est pas disponible : messages zod, constantes.
 * Se traduit avec `useTranslateMessage`.
 *
 * @example z.string().max(35, i18nMessage("validation:maxLength", { max: 35 }))
 */
export const i18nMessage = (key: I18nKey, values?: Record<string, string | number>): string =>
  values ? JSON.stringify({ key, values }) : key;

export const parseI18nMessage = (
  message: string,
): { key: string; values?: Record<string, string | number> } => {
  if (message.startsWith("{")) {
    try {
      const parsed = JSON.parse(message);
      if (typeof parsed?.key === "string") return parsed;
    } catch {
      // pas un message i18n sérialisé
    }
  }
  return { key: message };
};
